import {
    Braces,
    FileCode,
    FileJson,
    FileSpreadsheet,
    FileText,
    FileType2,
    Globe
} from "lucide-react";

import { TableExportFormat } from "@/api/form";

import { TableActionOption } from "@/pages/form/final/table-action-modal";

export const tableExportOptions: TableActionOption<TableExportFormat>[] = [
    {
        value: "xlsx",
        title: "Excel (.xlsx)",
        subtitle: "گزینه مناسب برای ویرایش پیشرفته، فرمول، فیلتر و نمودار",
        icon: FileSpreadsheet
    },
    {
        value: "csv",
        title: "CSV (.csv)",
        subtitle: "فرمت سبک و سریع برای انتقال داده",
        icon: FileText
    },
    {
        value: "pdf",
        title: "PDF (.pdf)",
        subtitle: "مناسب برای چاپ، گزارش رسمی و ارسال",
        icon: FileType2
    },
    {
        value: "docx",
        title: "Word (.docx)",
        subtitle: "مناسب برای گزارش های مدیریتی",
        icon: FileCode
    },
    {
        value: "json",
        title: "JSON (.json)",
        subtitle: "مناسب برای توسعه دهندگان و یکپارچه سازی API",
        icon: FileJson
    },
    {
        value: "xml",
        title: "XML (.xml)",
        subtitle: "مناسب برای سیستم های قدیمی تر",
        icon: Braces
    },
    {
        value: "txt",
        title: "TXT (.txt)",
        subtitle: "خروجی متنی ساده",
        icon: FileText
    },
    {
        value: "html",
        title: "HTML Table (.html)",
        subtitle: "مناسب برای استفاده در وب سایت یا ایمیل",
        icon: Globe
    }
];